import styled from "styled-components";
import { size } from "styled-theme";

export const YesLoansContent = styled.div`
    text-align: center;
    padding-left: 30px;
    padding-top: 10px;

    @media only screen and (min-width: ${size("M")}) {
    padding-top: 30px;
  }
`;